export default __webpack_public_path__ + "static/media/0xdf9b4b57865b403e08c85568442f95c26b7896b0.1999ccae.webp";